import React from "react";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {canViewConsentTemplates} from "@source/utils/consentAccess";
import {NewCategory} from "./newCategory";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const NewCategoryPage = () => {
  const organizationId = nursingHomeStore.activeNursingHome?.organization?._id || "";
  return <ConsentDocumentsLayout>{organizationId ? <NewCategory organizationId={organizationId} canReadTemplates={canViewConsentTemplates()}/> : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home with an organization to view Consent Categories."/ >}</ConsentDocumentsLayout>;
};
